import React from 'react';
import { Progress } from 'antd';
import { ClipboardList, CircleCheck, TrendingUp } from 'lucide-react';
import { StatCard } from '../../common';
import { formatNumber } from '../../../utils/format';
import { semantic } from '../../../theme/tokens';

/** Score % → tone (passing grade is 70%). */
export const scoreTone = (percentage) => {
    const value = parseFloat(percentage) || 0;
    if (value >= 70) return 'success';
    if (value >= 50) return 'warning';
    return 'danger';
};

export default function PollAnalytics({ polls }) {
    const analytics = React.useMemo(() => {
        const totalPolls = polls?.length || 0;

        // Calculate average percentage
        const pollsWithPercentage = polls?.filter((p) => p.percentage !== undefined && p.percentage !== null) || [];
        const avgPercentage =
            pollsWithPercentage.length > 0
                ? pollsWithPercentage.reduce((sum, p) => sum + (parseFloat(p.percentage) || 0), 0) / pollsWithPercentage.length
                : 0;

        // Count high scores (>= 70%)
        const highScores = polls?.filter((p) => parseFloat(p.percentage) >= 70)?.length || 0;

        return { totalPolls, avgPercentage, highScores };
    }, [polls]);

    const avgTone = scoreTone(analytics.avgPercentage);

    return (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            <StatCard label="Total Encuestas" value={formatNumber(analytics.totalPolls)} icon={<ClipboardList />} tone="brand" hint="Encuestas completadas" />
            <StatCard
                label="Promedio General"
                value={`${analytics.avgPercentage.toFixed(1)}%`}
                valueTone={avgTone}
                icon={<TrendingUp />}
                tone={avgTone}
                hint="Porcentaje promedio"
                footer={<Progress percent={analytics.avgPercentage} showInfo={false} strokeColor={semantic[avgTone].solid} size={['100%', 6]} className="!m-0" />}
            />
            <StatCard
                label="Aprobados"
                value={formatNumber(analytics.highScores)}
                valueTone="success"
                icon={<CircleCheck />}
                tone="success"
                hint="Con ≥70% de puntaje"
            />
        </div>
    );
}
